import React, { FC, useState } from "react";
import IntegrationCard from "./IntegrationCard";

interface IntegrationSnapshotProps {
    customText?: JSX.Element | string;
}

const items = [
    {
        logo: "https://assets.gallabox.com/gb-home/partnership/superleap-logo.png",
        title: "Superleap",
        subtext: "CRM",
        description: "Get smarter lead engagement with a seamless AI sync between Gallabox and Superleap CRM",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-zoho.png",
        title: "Zoho",
        subtext: "CRM",
        description: "Get a single source of truth with a two-way sync between Gallabox and Zoho CRM",
        link: "https://gallabox.com/whatsapp-integrations/zoho",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-hubspot.png",
        title: "HubSpot",
        subtext: "CRM",
        description: "Unify communication by integrating HubSpot with your WhatsApp Business account",
        link: "https://gallabox.com/whatsapp-integrations/hubspot",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/leadsquared-pillar-icon.png",
        title: "LeadSquared",
        subtext: "CRM",
        description: "Interact with your CRM leads and customers on WhatsApp in a hassle-free way",
        link: "https://gallabox.com/whatsapp-integrations/lead-squared",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/odoo-pillar-icon.png",
        title: "Odoo",
        subtext: "CRM",
        description: "Send automated notifications and alerts to your Odoo contacts through WhatsApp",
        link: "https://gallabox.com/whatsapp-integrations/odoo",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-kylas.png",
        title: "Kylas",
        subtext: "CRM",
        description: "Extend your Kylas CRM functionality to do more by connecting it with Gallabox",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/corefactors.svg",
        title: "Corefactors",
        subtext: "CRM",
        description: "Efficiently manage conversations with prospects and customers directly from the Corefactors CRM.",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/kondesk.jpg",
        title: "KONDESK",
        subtext: "CRM",
        description: " KONDESK is a CRM software with a one-stop solution to manage numerous features.",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/ledsak.png",
        title: "LEDSAK",
        subtext: "CRM",
        description: "Engage, nurture, and convert your leads effortlessly on WhatsApp through LEDSAK's powerful automation.",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-razorpay.png",
        title: "Razorpay",
        subtext: "Payments",
        description: "Collect payments on WhatsApp by integrating your Razorpay account with WhatsApp",
        link: "https://gallabox.com/whatsapp-integrations/razorpay",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-cashfree.png",
        title: "Cashfree",
        subtext: "Payments",
        description: "Accept payments on WhatsApp by connecting your CashFree account effortlessly",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-shopify.png",
        title: "Shopify",
        subtext: "D2C",
        description: "Connect Shopify to WhatsApp to share order updates, abandoned cart alerts, and more",
        link: "https://gallabox.com/whatsapp-integrations/shopify",
    },
    // {
    //     logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-woo.png",
    //     title: "WooCommerce",
    //     subtext: "D2C",
    //     description: "Bring your WooCommerce store into WhatsApp and watch your sales soar higher.",
    //     link: "https://gallabox.com/whatsapp-integrations/woocommerce",
    // },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-shiprocket.png",
        title: "Shiprocket",
        subtext: "Logistics",
        description: "Send timely shipping alerts to your customers on WhatsApp and keep them in the loop",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-facebook.png",
        title: "Facebook",
        subtext: "Marketing",
        description: "Push your Facebook leads to WhatsApp and nudge them towards conversion",
        link: "https://gallabox.com/whatsapp-integrations/facebook-leads-to-whatsapp",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-sheets.png",
        title: "Google Sheets",
        subtext: "Connectors",
        description: "Eliminate manual intervention and errors by seamlessly integrating with Google Sheets",
        link: "https://gallabox.com/whatsapp-integrations/google-sheets",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-pabbly.png",
        title: "Pabbly Connect",
        subtext: "Connectors",
        description: "With our Pabbly Connect integration, connect with the tools you use every day instantly",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-zapier.png",
        title: "Zapier",
        subtext: "Connectors",
        description: "Connect your software stack effortlessly with your WhatsApp account through Zapier",
        link: "https://gallabox.com/whatsapp-integrations/zapier",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/viaSocket.png",
        title: "ViaSocket",
        subtext: "Connectors",
        description: "viaSocket is an AI-driven, no-code workflow automation tool that connects over 5,000 apps to streamline tasks and boost productivity.",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-zohobooks.png",
        title: "Zoho Bookings",
        subtext: "Scheduler",
        description: "Access your calendar and empower your staff to manage their calendars from Gallabox",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-calendly.png",
        title: "Calendly",
        subtext: "Scheduler",
        description: "Send Booking Confirmations via WhatsApp Instantly",
        link: "https://gallabox.com/whatsapp-integrations/calendly",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-zohomeetings.png",
        title: "Zoho Meetings",
        subtext: "Scheduler",
        description: "Manage registrations for your Zoho meetings on WhatsApp with this Gallabox connector",
        link: "https://app.gallabox.com/signup",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-zohobooking.png",
        title: "Zoho Books",
        subtext: "Accounting",
        description: "Streamline accounting and simplify your reconciliation with our Zoho Books connector",
        link: "https://gallabox.com/whatsapp-integrations/zoho-books",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/moengage-pillar-icon.png",
        title: "MoEngage",
        subtext: "Marketing",
        description: "Make your customer engagement activities cost-effective with our MoEngage connector",
        link: "https://gallabox.com/whatsapp-integrations/moengage",
        tags: ["crm"],
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-webengage.png",
        title: "WebEngage",
        subtext: "Marketing",
        description: "Elevate your customer engagement by sending them automated nudges on WhatsApp",
        link: "https://gallabox.com/whatsapp-integrations/webengage",
    },
];

const IntegrationSnapshot: FC<IntegrationSnapshotProps> = (props) => {
    const filters = ["All", "CRM", "Payments", "D2C", "Accounting", "Scheduler", "Logistics", "Marketing", "Connectors"];
    const { customText = "A Snapshot of Our Integrations" } = props;
    const [filteredData, setFilteredData] = useState<Array<any>>(items);
    const [currIndex, setCurrIndex] = useState<number>(0);

    const handleBtnSelect = (title: string, index: number) => {
        setCurrIndex(index);

        if (title !== "All") {
            const data = items.filter((item) => item.subtext === title);
            setFilteredData(data);
        } else {
            setFilteredData(items);
        }
    };

    return (
        <section className="py-10  mx-auto" style={{ maxWidth: "1200px" }}>
            <div className="mx-auto text-center rounded">
                <div className="text-2xl md:text-3xl font-bold lg:mb-10 mb-4 inline-block  text-gray-700">{customText}</div>
                <div className="flex-row lg:block hidden pb-0 mb-4 bg-blue-50 rounded-xl">
                    {filters.map((filter, index) => (
                        <button
                            key={filter}
                            onClick={() => handleBtnSelect(filter, index)}
                            className={`${index === currIndex && "shadow-xl bg-gray-50"}`}
                            style={{
                                borderRadius: "6px",
                                border: "1px solid var(--blue-200, #90CDF4)",
                                background: "#FFF",
                                margin: "5px 5px 5px 5px",
                                outline: "none",
                            }}
                        >
                            <div className="flex row justify-center">
                                <p style={{ margin: "10px 30px 10px 30px" }}>{filter}</p>
                            </div>
                        </button>
                    ))}
                </div>

                <IntegrationCard items={filteredData} />
            </div>
        </section>
    );
};

export default IntegrationSnapshot;
